import axios from 'axios'
import ActionsLogin from './LoginActions'

const config = {
  headers: {
    Authorization: 'Bearer ' + ActionsLogin.getToken()
  }
}

const listar = () => {
  return axios.get(
      `${process.env.URL_API_MENSAGEM}/message-history`,
      config
    )
    .then(response => response.data)
}

const obterPorCodigoMotorista = (codigoMotorista) => {
  return axios.get(
      `${process.env.URL_API_MENSAGEM}/message-history/obter-por-motorista/${codigoMotorista}`,
      config
    )
    .then(response => response.data)
}

export default {
  listar,
  obterPorCodigoMotorista
}



// WEBPACK FOOTER //
// ./src/actions/MensagemHistoricoActions.js